import { type WpUserPaymentToken } from '@dni-types/data-models/ecommerce-payment'

/**
 * 格式化到期日為 MM/YY 格式
 */
export function formatExpiryDate(month: string, year: string): string {
  const formattedMonth = month.padStart(2, '0')
  const formattedYear = year.slice(-2)
  return `${formattedMonth}/${formattedYear}`
}

/**
 * 檢查信用卡是否已過期
 */
export function isCardExpired(month: string, year: string, referenceDate: Date): boolean {
  const expiryDate = new Date(parseInt(year, 10), parseInt(month, 10), 0)
  return referenceDate > expiryDate
}

/**
 * 檢查持卡人資訊是否完整
 */
export function isCardholderInfoComplete(cardholder: WpUserPaymentToken['cardholder']): boolean {
  if (!cardholder) return false
  const hasEmail = !!cardholder.email
  const hasPhone = !!(cardholder.phone_number && cardholder.phone_number_country_code)
  return !!(cardholder.name_en && (hasEmail || hasPhone))
}
